import "./App.css";
import Navbar from "./components/Navbar";
import Contact from "./components/Contact";
import Home from "./components/Home";
import ACS from "./components/new_components/ACS";
import Security from "./components/new_components/Security";
import IT from "./components/new_components/IT";
import Tutoring from "./components/new_components/Tutoring";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <ACS />
      <Security />
      <IT />
      <Tutoring />
      <Contact />
    </div>
  );
}

export default App;
